/* unplugin-vue-components disabled */import script from "./area.vue?vue&type=script&setup=true&lang=js"
export * from "./area.vue?vue&type=script&setup=true&lang=js"

import "./area.vue?vue&type=style&index=0&id=786680a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786680a2"]])

export default __exports__